import 'dayjs/locale/de';
import { MantineProvider as NativeMantineProvider } from '@mantine/core';
import '@mantine/core/styles.layer.css';
import '@mantine/dates/styles.css';
import 'mantine-datatable/styles.layer.css';
import '@mantine/spotlight/styles.css';
import '@mantine/dropzone/styles.css';
import '@mantine/schedule/styles.css';
import { DatesProvider } from '@mantine/dates';
import { ModalsProvider } from '@mantine/modals';
import { theme } from '../../theme';

type MantineProviderPropsType = {
  children: React.ReactNode;
};

export const MantineProvider: React.FC<MantineProviderPropsType> = ({
  children,
}) => {
  return (
    <>
      {/* 👇 this makes sure the styles are applied in the correct order */}
      <style>{`@layer mantine, mantine-datatable;`}</style>
      <NativeMantineProvider theme={theme}>
        <DatesProvider settings={{ locale: 'de', firstDayOfWeek: 1 }}>
          <ModalsProvider>{children}</ModalsProvider>
        </DatesProvider>
      </NativeMantineProvider>
    </>
  );
};
